import { BrandingView } from "../_components";

export default function DevicesBrandingPage() {
  return <BrandingView />;
}
